module.exports = __webpack_public_path__ + "static/img/img_awards_6en.0cbbe82.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/english/img_awards_6en.png
// module id = cOgo
// module chunks = 15